import {
    Button,
    Grid,
    IconButton,
    Modal,
    Stack,
    Typography,
  } from '@mui/material'
  import React from 'react'
  import closeicon from 'shared/assets/icons/successclose.png'
  import tickmark from 'shared/assets/icons/AllSettick.png'
import { useNavigate } from 'react-router-dom'
import { FetchProfile } from 'shared/redux/profile/ProfileSlice'
import { useAppDispatch } from '../../../app/hooks'

  interface SuccessSubmitModalProps {
    open: boolean
    setOpen: (open: boolean) => void
  }
  
  const SuccessSubmitModal = (props: SuccessSubmitModalProps) => {
    const navigate=useNavigate()
  const dispatch = useAppDispatch()

    const handleClose = () => {
      navigate('/dashboard')
      window.location.reload()

      props.setOpen(false)
    setTimeout(() => {
      dispatch(FetchProfile())
    }, 5000)
    }
    return (
      <Modal
        open={props.open}
        sx={{
          backdropFilter: 'blur(5px)',
          background: 'rgba(0, 0, 0, 0.01)',
        }}
        onClose={handleClose}>
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          sx={{
            outline: 'none',
            position: 'relative',
            top: '50%',
            left: '50%',
            maxWidth: '600px',
            transform: 'translate(-50%, -50%)',
            width: {xs: '80%', sm: '50%', md: '40%', lg: '30%'},
            background: '#fff',
            p: 10,
            borderRadius: '10px',
          }}>
          <IconButton
            edge="end"
            color="inherit"
            onClick={handleClose}
            sx={{
              position: 'absolute',
              top: 5,
              right: 20,
              zIndex: 10,
              color: '#ffffff',
            }}>
            <img src={closeicon} style={{ width: '42px' }} />
          </IconButton>
          <Stack  justifyContent="center" 
    alignItems="center" flexDirection={'column'}>
          <img src={tickmark} style={{ width: '100px' }} />
          <Typography mb={2} mt={10} textAlign="center"
          sx={{
              fontFamily: 'InterBold',
              fontSize: {xs: 18, md: 21, lg: 23},
              fontWeight: 600,
              lineHeight: {xs: 1, md: 1.2, lg: 1.5},
            }}>
          All Set!
          </Typography>
         
          <Typography textAlign="center"color={'#615F6B'}
          sx={{
              fontFamily: 'InterRegular',
              fontSize: {xs: 12, md: 14, lg: 16},
              lineHeight: {xs: 1.2, md: 1.2, lg: 1.5},
          }}>
          Your changes were successfully saved.
          </Typography>
          <Typography mb={2} textAlign="center" color={'#615F6B'}
          sx={{
            fontFamily: 'InterRegular',
              fontSize: {xs: 12, md: 14, lg: 16},
              lineHeight: {xs: 1.2, md: 1.2, lg: 1.5},
          }}>
          Please come back later.
          </Typography>
         </Stack>
        
            <Grid item xs={6} sm={6} mt={5}>
              <Button
                variant={'contained'}
                color={'darkPurple'}
                onClick={handleClose}
                sx={{
                  width: '100%',
                  fontSize: {xs: 12, sm: 10, md: 12, lg: 15},
                  borderRadius: '10px',
                  boxShadow: 'unset',
                  border: '2px solid #C67EFF',
                  fontFamily: 'InterBold',
                  background: 'transparent',
                  color: '#C67EFF',
                  '&.Mui-disabled': {
                    background: 'transparent',
                    color: '#C67EFF',
                  },
                  ':hover': {
                    background: 'transparent',
                    color: '#C67EFF',
                  },
                }}>
                Done
              </Button>
            </Grid>
        </Grid>
      </Modal>
    )
  }
  
  export default SuccessSubmitModal
  